const MIN_PROVIDER_ID_DIGITS = 15;

export function looksLikeProviderId(
  value?: string | null,
): boolean {
  if (!value || !value.trim()) {
    return true;
  }
  const stripped = value.trim();
  if (stripped.includes("|")) {
    return true;
  }
  if (/^\d+$/.test(stripped) && stripped.length >= MIN_PROVIDER_ID_DIGITS) {
    return true;
  }
  return false;
}

export function humanDisplayName(
  ...candidates: Array<string | null | undefined>
): string {
  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }
    const stripped = candidate.trim();
    if (stripped.includes("@")) {
      const local = stripped.split("@")[0];
      if (local && !looksLikeProviderId(local)) {
        return local;
      }
      continue;
    }
    if (!looksLikeProviderId(stripped)) {
      return stripped;
    }
  }
  return "Anonymous";
}
